import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import CommonTile from "./CommonTile";
import { currencyCodeFormatter } from "~/components/Metrics/Charts/Common";
import { PERMISSION } from "~/api/permissions/enums";
import usePermissions from "~/hook/usePermissions";
import api from "~/api";

const AverageBillTile = () => {
  const { t } = useTranslation();
  const { hasAll } = usePermissions();
  const onUpdate = useCallback(async () => {
    try {
      const {
        data: { data },
      } = await api.dashboardMetrics.getBillsMetric();
      return data;
    } catch (error) {
      console.error(error);
    }
  }, []);

  if (!hasAll(PERMISSION.READ_MONEY_METRICS)) return null;

  return (
    <CommonTile
      label={t("title.averageBill")}
      trendDescription={t("text.lastWeek")}
      formattingValue={currencyCodeFormatter}
      onUpdate={onUpdate}
    />
  );
};

export default AverageBillTile;
